<template>
  <w-dialog :dialog-show="state" :top="15" @handleClose="handleClose">
    <div class="over-match-wrapper" slot="content" @touchmove.prevent>
      <div class="flex-between header">
        <div class="match-header">
          <p class="headline title">大牛简历</p>
          <p class="sub-title">各行业优秀简历供你参考</p>
        </div>
        <span class="iconfont iconx" @click="handleClose"/>
      </div>
      <div class="img-wrapper">
        <img src="https://files.wondercv.com/m-editor/match.png" alt="">
      </div>
      <button class="theme-button bottom" @click="toTemplate">去看看</button>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '../../components/global/w-dialog'

	export default {
		name: 'over-match-cv',
		props: {
			state: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			},
			toTemplate () {
				window.location.href = `/jianlimoban/tuijian/`
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  .over-match-wrapper {
    width: 90vw;
    padding: 24px 24px 32px;
    background-color: $color-light;
    border-radius: 8px;
    .header {
      position: relative;
      align-items: flex-start;
      margin-bottom: 16px;
      .match-header {
        width: 100%;
        text-align: center;
        .title {
          line-height: 22px;
          margin-bottom: 4px;
        }
        .sub-title {
          color: $color-dark-gray;
          line-height: 20px;
        }
      }
      .iconx {
        position: absolute;
        top: 0;
        right: 0;
        color: #8C8C8C;
        font-weight: bold;
        font-size: 18px;
      }
    }
    .img-wrapper {
      margin-bottom: 16px;
      img {
        width: 100%;
      }
    }
    .bottom {
      width: 100%;
      height: 40px;
      border-radius: 4px;
      font-size: $font-size-medium-x;
    }
  }
</style>
